import { COMING_SOON_TAG, getHotspotPopupContent } from "../lib/hotspotPopupContent";

export default function HotspotPopup({ hotspotId, onClose }) {
  const content = getHotspotPopupContent(hotspotId);
  if (!content) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 font-['DM_Sans']"
      style={{ background: "rgba(15,23,42,0.55)", backdropFilter: "blur(4px)", zIndex: 9999 }}
      onClick={onClose}
    >
      <div
        className="w-full max-w-[420px] max-h-[min(520px,88vh)] flex flex-col overflow-hidden rounded-xl shadow-[0_20px_60px_rgba(0,0,0,0.35)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="flex items-center justify-between flex-shrink-0 px-4 py-3"
          style={{ background: "#1E293B", borderBottom: "1px solid rgba(255,255,255,0.08)" }}
        >
          <h2 className="text-[14px] font-bold text-white m-0 pr-3 leading-snug">{content.title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="flex-shrink-0 bg-transparent border-none text-white/50 text-lg cursor-pointer leading-none px-1 py-0 hover:text-white/80"
          >
            ✕
          </button>
        </div>

        <div className="flex-1 overflow-y-auto bg-white px-5 py-4">
          <p className="text-[13px] text-slate-700 leading-[1.65] m-0 whitespace-pre-wrap">{content.body}</p>
          {content.showTag && (
            <p
              className="text-[11px] text-slate-400 italic mt-4 mb-0 pt-3 leading-[1.5]"
              style={{ borderTop: "1px solid #F1F5F9" }}
            >
              {content.tag ?? COMING_SOON_TAG}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
